import { Plugin } from "@ckeditor/ckeditor5-core";
import { ButtonView } from "@ckeditor/ckeditor5-ui";

import MediaIcon from "./media.svg";

export default class MediaInsertUI extends Plugin {
  destroy() {
    console.debug("Removing listener for cde:openInsertMediaDialog");
    this.editor.off("cde:openInsertMediaDialog");
    this.editor.off("change:isReadOnly");
  }

  init() {
    const editor = this.editor;
    //const t = editor.t;

    editor.ui.componentFactory.add("insertMedia", (locale) => {
      const insertMediaButtonView = new ButtonView();

      insertMediaButtonView.set({
        icon: MediaIcon,
        isOn: false,
        label: "Insert Media",
        tooltip: true,
      });

      insertMediaButtonView.bind("isOn", "isEnabled");
      insertMediaButtonView.on("execute", (e) => {
        editor.fire("cde:openInsertMediaDialog");
      });
      editor.on("change:isReadOnly", (_event, _propertyName, value) => {
        insertMediaButtonView.isEnabled = !value;
      });

      return insertMediaButtonView;
    });
  }
}
